import { CrudCollection } from "../CrudCollection";

export function readCollectionQueryState(
  collection: CrudCollection
): Record<string, string> {
  return Object.entries(
    collection.remoteQueryValues as Record<string, any>
  ).reduce(
    (state, [key, value]) => {
      if (
        key === "_page" ||
        value === undefined ||
        value === null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0)
      ) {
        return state;
      }

      state[key] = Array.isArray(value)
        ? value.map(String).join(",")
        : String(value);

      return state;
    },
    {} as Record<string, string>
  );
}

export function applyCollectionQueryState(
  collection: CrudCollection,
  state: Record<string, any>
): void {
  Object.keys(state)
    .filter((key) => !key.startsWith("_"))
    .filter((key) => collection.getFilter(key))
    .forEach((key) => collection.setFilter(key, state[key]));

  Object.keys(state)
    .filter((key) => key.startsWith("_"))
    .map((key) => key.substring(1))
    .filter((queryOption) =>
      collection.remoteQueryOptions.hasOwnProperty(queryOption)
    )
    .forEach((queryOption) => {
      const key = `_${queryOption}`;
      const rawValue = state[key];
      let optionValue = rawValue;

      if (queryOption.startsWith("sort")) {
        const serializedValue = Array.isArray(rawValue)
          ? rawValue.join(",")
          : String(rawValue);
        optionValue =
          serializedValue === "" ? [] : serializedValue.split(",");

        if (queryOption === "sortDesc") {
          optionValue = optionValue.map(Number);
        }
      }

      collection.setQueryOption(
        queryOption as keyof typeof collection.remoteQueryOptions,
        optionValue
      );
    });

  collection.applyStagedFilters();
}
